/*
 *=========================================================================================
 *File Name: state.js
 *Description: Vuex Store - state
 *----------------------------------------------------------------------------------------
 *Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
 *Author: Pixinvent
 *Author URL: http://www.themeforest.net/user/pixinvent
 *==========================================================================================
 */

import navbarSearchAndPinList from "@/components/widgets/navbar/navbarSearchAndPinList";
import themeConfig from "@/../themeConfig.js";
import colors from "@/../themeConfig.js";
import ProspectSearch from "../entities/ProspectSearch";

// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

/*
 * Check if device is touch device
 * This is used to remove perfect scrollbar from touch devices
 * Using Dynamic components
 */
const is_touch_device = () => {
	var prefixes = " -webkit- -moz- -o- -ms- ".split(" ");
	var mq = function(query) {
		return window.matchMedia(query).matches;
	};

	if("ontouchstart" in window || window.DocumentTouch) {
		return true;
	}

	/*
	 * include the 'heartz' as a way to have a non matching MQ to help terminate the join
	 * https://git.io/vznFH
	 */
	var query = ["(", prefixes.join("touch-enabled),("), "heartz", ")"].join("");
	return mq(query);
};
// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
	activeUser: {},
	activeUserSociety: null,
	statDateFilter: {},
	// Backlinks selection state
	backlinksSelectedIds: [], // Changed from Set to Array for Vue 2 reactivity
	backlinksCurrentPageSelected: [],
	societies: [],
	societies_tags: [],
	contracts: [],
	contracts_users: [],
	contracts_contracts_users: [],
	contracts_documents_types: [],
	countries: [],
	personalNotification: {},
	dns: [],
	societiesOption: [],
	docTypeList: [],
	filterRowNum: 0,
	noteCommerical: null,
	missions: [],
	netlink: [],
	netlink_types: [],
	notifications: [],
	notifications_types: [],
	purchases: [],
	thisContractTasks: [],
	providers: [],
	providers_tags: [],
	services: [],
	contacts: [],
	collaborators: [],
	collaborators_avatar: [],
	customers: {},
	commandes: [],
	showAddNewCommandePopup: false,
	isEditCommandebtn: false, //editing commade btn
	showFlexiblePopup: false,
	flexiblePopupContractId: null,
	flexiblePopupLeadConsultantId: null,
	products: [],
	products_categories: [],
	products_sub_categories: [],
	ps: [],
	reports: [],
	users: [],
	users_societies: [],
	tasks: [],
	filterFields: {},
	terms: [],
	tva_ids: [],
	previousSociety: null,
	backendApiUrl: process.env.VUE_APP_API_URL,
	bodyOverlay: false,
	isVerticalNavMenuActive: true,
	is_touch_device: is_touch_device(),
	mainLayoutType: themeConfig.mainLayoutType || "vertical",
	navbarSearchAndPinList: navbarSearchAndPinList,
	reduceButton: themeConfig.sidebarCollapsed,
	verticalNavMenuWidth: "default",
	verticalNavMenuItemsMin: false,
	scrollY: 0,
	starredPages: navbarSearchAndPinList["pages"].data.filter(
		page => page.is_bookmarked
	),
	theme: themeConfig.theme || "light",
	themePrimaryColor: colors.primary,

	/*
	 * Can be used to get current window with
	 * Note: Above breakpoint state is for internal use of sidebar & navbar component
	 */
	relanceFilter: {
		commercialFilter: null,
		contractNumberFilter: null,
		societyFilter: null,
		endDateFilter: null,
		startDateFilter: null,
		typeFilter: [],
		statusFilter: "0"
	},
	windowWidth: null,
	windowHeigth: 0,
	filterCardHeight: 0,
	horizentalNavBarHeight: 0,
	isFilterDown: false,
	tableHeight: 0,
	isContractPopUp: false,
	isNotifPopUp: false,
	redac_lang: [],
	flexibleMissions: [],
	contentProducts: [],
	netlinkThemas: [],
	netlinkIntl: [],
	allOrderList: [],
	// Prospects
	prospects_projects: [],
	newProspects: ProspectSearch.getFormFields(),
	oldProspects: ProspectSearch.getFormFields(),
	prospects: [],
	keywordListByAi: [],
	// google ads
	googleAds: [],

	// Keywords
	keywordsCategories: [],
};

export default state;
